// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"pg-service-user-profile-common":"76935a1e0c63abc5dc80","UserProfileWelcome":"84eb74d17f3a1aca46dd","UserProfileCard":"eaed27554f235be4f4a6"}[chunkId] + ".bundle.js";
};